import Vue from 'vue';
import gaService from './ga.service';

export default {
    async openSession(gameId) {
        gaService.send('games', 'baas', gameId);
        return (await Vue.http.get(`/api/baas/session/open/${gameId}`)).data;
    },
    async openDemoSession(gameId) {
        gaService.send('games', 'baas', gameId);
        return (await Vue.http.get(`/api/baas/session/opendemo/${gameId}`)).data;
    }
}



// WEBPACK FOOTER //
// ./_common/services/baas.service.js